var activeProducts = document.querySelectorAll(".cb-configurator__chocolate-selector__grid__item.in-stock");
var normalSelectedProducts = [];
var premiumSelectedProducts = [];
var datapremium= 0;

activeProducts.forEach(function(item) {
  item.addEventListener("click", function() {
      updatedData(item , "add")
  });
});

function updatedData(item, condtion){

    var totalNormalCandies = parseInt(document.querySelector(".cb-configurator__chocolate-selector__right.active-div").getAttribute('data-total-normal-candies'), 10);
    var totalPremiumCandies = parseInt(document.querySelector(".cb-configurator__chocolate-selector__right.active-div").getAttribute('data-total-premium-candies'), 10);
     
     var some_value =  normalSelectedProducts.length + premiumSelectedProducts.length;
  
     if(condtion == "add" && some_value < totalNormalCandies){
      var itemData = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image');
       if(item.dataset.productTags.includes('Premium')){
         var mainContentPremiumImage = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image').getAttribute('data-normal-collection');
       }else{
         var mainContentNormalImage = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image').getAttribute('data-normal-collection');
       }
      // var mainContentNormalImage = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image').getAttribute('data-normal-collection');
      // var mainContentPremiumImage = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image').getAttribute('data-premium-collection');
       some_value+=1;
      if (normalSelectedProducts.length < totalNormalCandies && mainContentNormalImage !== undefined) {
        normalSelectedProducts.push(itemData);
        
      } else if (premiumSelectedProducts.length < totalPremiumCandies && mainContentPremiumImage !== undefined) {
        premiumSelectedProducts.push(itemData);
      }
    }
  
    if(condtion == "remove" && item.childNodes[0].dataset.premiumCollection){
      datapremium=0
    }

    var activeDiv = document.querySelector('.cb-configurator__chocolate-selector__right.active-div');
    var gridItems = activeDiv.querySelectorAll('.cb-configurator__chocolate-selector__grid__item');
    var totalItemsToDisplay = normalSelectedProducts.length + premiumSelectedProducts.length;
    var maxNormalToDisplay = Math.min(totalNormalCandies, normalSelectedProducts.length);
    var maxPremiumToDisplay = Math.min(totalPremiumCandies, premiumSelectedProducts.length);
    var itemsToShowFromPremium = Math.min(maxPremiumToDisplay, totalItemsToDisplay);
    var itemsToShowFromNormal = Math.min(maxNormalToDisplay, totalItemsToDisplay - itemsToShowFromPremium);


    gridItems.forEach(function(item) {
      item.innerHTML = '';
      item.classList.add("empty")
    });


   
      if(premiumSelectedProducts.length == totalPremiumCandies && item.dataset.premiumCollection ){
        if(datapremium > 0){
        if(premiumSelectedProducts.length == 6){
          document.querySelector('#popup_content_box').innerHTML =`
          <div class="modal show-modal">
            <div class="modal-content">
              <span class="close-button">×</span>
              <h1> Please choose a non-premium gummy, as you’ve reached your limit for ${totalPremiumCandies} premium candies at this size.</h1>
            </div>
          </div>`
        }else{
          document.querySelector('#popup_content_box').innerHTML =`
          <div class="modal show-modal">
            <div class="modal-content">
              <span class="close-button">×</span>
              <h1> Please choose a non-premium gummy, as you’ve reached your limit of ${totalPremiumCandies} for premium candies at this size. To include more premium options, you can update your size selection.</h1>
            </div>
          </div>`
        }
        
        }
        datapremium=1
      }

    var itemsToShowFromPremium = Math.min(maxPremiumToDisplay, totalItemsToDisplay);
    var itemsToShowFromNormal = Math.min(maxNormalToDisplay, totalItemsToDisplay - itemsToShowFromPremium);
    
    gridItems.forEach(function(item, index) {
      if (index < itemsToShowFromPremium) {
        item.innerHTML = premiumSelectedProducts[index]?.outerHTML || '';
        item.classList.remove("empty");
      } else if (index < itemsToShowFromPremium + itemsToShowFromNormal) {
        item.innerHTML = normalSelectedProducts[index - itemsToShowFromPremium]?.outerHTML || '';
        item.classList.remove("empty");
      } else {
        item.innerHTML = '';
      }
    });
 
    // gridItems.forEach(function(item, index) {
    //   
    //   if (index < maxNormalToDisplay) {
    //     item.innerHTML = normalSelectedProducts[index]?.outerHTML || '';
    //     item.classList.remove("empty")
    //   }
    //   else if (index < maxPremiumToDisplay + maxNormalToDisplay) {
    //     item.innerHTML = premiumSelectedProducts[index - maxNormalToDisplay]?.outerHTML || '';
    //      item.classList.remove("empty")
    //   } else {
    //     item.innerHTML = '';
    //   }
    // });

  if(totalItemsToDisplay == totalNormalCandies){
    const buttonElement = document.querySelector('.cb-configurator__step__content-frame__buttons__button');
    const currentScroll = window.scrollY;
    const buttonPosition = buttonElement.getBoundingClientRect().top + currentScroll;
    const scrollDistance = (buttonPosition - currentScroll) * 0.5;
    window.scrollBy({
        top: scrollDistance,
        behavior: 'smooth'
    });
     document.querySelector('.cb-configurator__step__content-frame__buttons__button').removeAttribute("disabled")
  }else{
    document.querySelector('.cb-configurator__step__content-frame__buttons__button').setAttribute("disabled", "");
  }
}



// REMOVE ITEM FORM AN ARRAY CODE START ------------------------
function handleItemClick(item) {
  
  var itemId = item.getAttribute('data-id'); // Use data-id to identify the item
  var itemData = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image');
  var activeDiv = document.querySelector('.cb-configurator__chocolate-selector__right.active-div');
  var totalNormalCandies = parseInt(activeDiv.getAttribute('data-total-normal-candies'), 10);
  var totalPremiumCandies = parseInt(activeDiv.getAttribute('data-total-premium-candies'), 10);
  var mainContentNormalImage = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image').getAttribute('data-normal-collection');
  var mainContentPremiumImage = item.querySelector('.cb-configurator__chocolate-selector__grid__item__image').getAttribute('data-premium-collection');
  
  var isNormal = mainContentNormalImage !== null;
  var isPremium = mainContentPremiumImage !== null;

  if (isNormal) {
    var index = normalSelectedProducts.findIndex(function(product) {
      return product.dataset?.variantId == itemData.dataset?.variantId;
    });
    if (index > -1) {
      normalSelectedProducts.splice(index, 1);
    }
  } else if (isPremium) {
    var index = premiumSelectedProducts.findIndex(function(product) {
      return product.dataset?.variantId == itemData.dataset?.variantId;
    });
    if (index > -1) {
      premiumSelectedProducts.splice(index, 1);
    }
  }

   updatedData(item , "remove")
}





//vs variants Click funciton ---------------------
var variants = document.querySelectorAll(".Ctm-variants-itg");
variants.forEach(function (item) {
  item.addEventListener("click", function (event) { 
     datapremium=0
        document.querySelector('.cb-configurator__step__content-frame.active').scrollIntoView({
          behavior: 'smooth',
          block: 'start', // Align the element at the top of the scrolling container
          inline: 'nearest' // Align the element in the horizontal direction
        });
     if( event.target.dataset?.variantId != ""){
       console.log(event.target.dataset?.variantId)
       document.querySelectorAll('.cb-configurator__chocolate-selector__right').forEach(function (maindiv) {
         if(maindiv.dataset?.mainProductvariant == event.target.dataset?.variantId){
            maindiv.classList.remove('hide-div');
             maindiv.classList.add('active-div')
         }else{
            maindiv.classList.add('hide-div')
            maindiv.classList.remove('active-div');
         }
       })
     }
      normalSelectedProducts = [];
      premiumSelectedProducts = [];
      updatedData(item , "remove")
  });
});



  // var activeDivDATA = document.querySelector('.cb-configurator__chocolate-selector__right.active-div');
  // var itemRemove = activeDivDATA.querySelectorAll(' .cb-configurator__chocolate-selector__grid__item);

  // itemRemove.forEach(function(item) {
  //   item.addEventListener("click", function() {
  //     console.log('chck')
  //     handleItemClick(item);
  //   });
  // });

$(document).on("click",".cb-configurator__chocolate-selector__right.active-div .cb-configurator__chocolate-selector__grid__item" ,function(){
  handleItemClick(this);
})
  
// filter box click function ---------------------
var filterBox = document.querySelectorAll(".cb-configurator__filters__filter");
filterBox.forEach(function (item) {
  item.addEventListener("click", function (event) {

  if(item.dataset?.premiumDisable == "true"){
    $('.premium_filter input').each(function(){
      $(this).prop('checked', true);
    });
    $('.normal-collection-input input').each(function(){
      $(this).prop('checked', false);
    });
    $('.tag_filter input').each(function(){
      $(this).prop('checked', false);
    });
     handleClick(false)
  }else  if(item.dataset?.normalDisable == "true"){
      var tagfilterData =  $('.tag_filter input:checked');
      var premiumfilterData =  $('.premium_filter input:checked');
    if(tagfilterData.length > 0 || premiumfilterData.length  >0 ){
       $('.premium_filter input').each(function(){
        $(this).prop('checked', false);
      });
      $('.tag_filter input').each(function(){
        $(this).prop('checked', false);
      });
      
      $('.normal-collection-input input:eq(0)').each(function(){
        $(this).prop('checked', true);
      });
    }
    
     item.classList.toggle("active");
      handleClick(true)
  }
  else{
     item.classList.toggle("active");
  }
  });
});







function handleClick(action) {
  
  if(action){
    var TagArray =["Premium","Sour",'3d','filled']
    const collectionIdArr = Array.from(
        document.querySelectorAll('.cb-configurator__filters__filter__dropdown__item input:checked')
    ).map(input => input.getAttribute('data-product-tag'));
    
    TagArray = TagArray.filter(tag => !collectionIdArr.includes(tag));
    document.querySelectorAll('.cb-configurator__chocolate-selector__grid__item.in-stock').forEach(div => {
        const tags = div.getAttribute('data-product-tags').split(',').map(tag => tag.trim());
        // var removeItemcheck =   TagArray.some(tag => tags.includes(tag))
        var shouldShow = collectionIdArr.length === 0 || (collectionIdArr.some(tag => tags.includes(tag))  );
        if (shouldShow) {
            div.classList.remove('hide-div');
        } else {
            div.classList.add('hide-div');
        }
    });
  }else{
      const collectionIdArr = Array.from(
        document.querySelectorAll('.cb-configurator__filters__filter__dropdown__item input:checked')
    ).map(input => input.getAttribute('data-collection-ids'));

    document.querySelectorAll('.cb-configurator__chocolate-selector__grid__item.in-stock').forEach(div => {
        const showCollection = div.dataset.allCollection;
        if (collectionIdArr.length === 0) {
            div.classList.remove('hide-div');
        } else if (collectionIdArr.includes(showCollection)) {
            div.classList.remove('hide-div');
        } else {
            div.classList.add('hide-div');
        }
    });
  }
}



document.querySelectorAll('.collection_filter').forEach(div => {
    div.addEventListener('click', handleClick);
  
});


// TAG FILTER CODE START HERE----------------------------------------[]
$(document).on("click", '.tag_filter', function() {
    const collectionIdArr = Array.from(
        document.querySelectorAll('.tag_filter input:checked')
    ).map(input => input.getAttribute('data-product-tag'));
    document.querySelectorAll('.cb-configurator__chocolate-selector__grid__item.in-stock').forEach(div => {
        const tags = div.getAttribute('data-product-tags').split(',').map(tag => tag.trim());
        const shouldShow = collectionIdArr.length === 0 || collectionIdArr.some(tag => tags.includes(tag));
        if (shouldShow) {
            div.classList.remove('hide-div');
        } else {
            div.classList.add('hide-div');
        }
    });
   // $(this).closest('.cb-configurator__filters__filter').removeClass("active");
  $('.collection_filter input').each(function(){
    $(this).prop('checked', false);
  })
});


$(document).on("click", '.collection_filter', function() {
   // $(this).closest('.cb-configurator__filters__filter').removeClass("active");
   $('.tag_filter input').each(function(){
    $(this).prop('checked', false);
  });
     $('.premium_filter input').each(function(){
      $(this).prop('checked', false);
    });
})

$(document).on("click", '.premium_filter', function() {
   // $(this).closest('.cb-configurator__filters__filter').removeClass("active");

   $('.tag_filter input').each(function(){
    $(this).prop('checked', false);
  })
   $('.collection_filter input[data-normal-collection-id]').each(function(){
    $(this).prop('checked', false);
  })
   // $('.cb-configurator__filters__filter__dropdown__item').removeClass('hide-div');
})



// CUSTOM ORDER BUTTON CLICK FUNCITON --------------[]

document.querySelector('.Ctm_order_button')?.addEventListener('click', function () {
    document.querySelector('.cb-configurator__step__content-frame.active').scrollIntoView({
        behavior: 'smooth',
        block: 'center', // Align the element in the center of the scrolling container
        inline: 'nearest' // Align the element in the horizontal direction (nearest)
    });
});









// ADD TO CART PRODUCT CODE START HERE-----------------------------------------[];
var ATC_Button = document.querySelector(".cb-configurator__step__content-frame__buttons__button");
  ATC_Button?.addEventListener("click",async function (event) {
      event.preventDefault();
     // var ATC = document.querySelector(".product-form__submit.button").hasAttribute("disabled");
    // var ATC = document.querySelector(".payment-buttons button[type=submit]").hasAttribute("disabled");
 // if(!ATC){
   $('.custom_button').removeClass('hidden')
   var Quantity = document.querySelector(".qty-actual__input").value;
   var main_product_properties = [];
    let formData = {}
    formData.items= []
      var activeDiv = document.querySelector('.cb-configurator__chocolate-selector__right.active-div');
     var variantsIDS = activeDiv.querySelectorAll('.cb-configurator__chocolate-selector__grid__item');
       variantsIDS.forEach(item => {
         
         main_product_properties.push(item.firstChild.dataset.productTitle)
         // main_product_properties.push(item.firstChild.dataset.variantId)
          // formData.items.push({
          //    "id" : item.firstChild.dataset.variantId,
          //    "quantity" :  Quantity,
          //    "properties":{
          //      'Customize_product': item.firstChild.dataset.variantId
          //    }
          // })
       });


main_product_properties = main_product_properties.join("<br/>");
// Set the value of the textarea to display the formatted content with line breaks
document.querySelector('#recipient-name').value = main_product_properties;

    // const lineItem = await addItem(formData);
    // if(lineItem){
      
      setTimeout(function(){
        // document.querySelector(".product-form__submit.button").click();
         document.querySelector('.payment-buttons button[type=submit]').click();
      },1000)
   setTimeout(function(){
    $('.custom_button').addClass('hidden')
   },2500)
    // }
   // }
  });


async function addItem(item) {
    try {
        const response = await fetch("/cart/add.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(item)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error adding item:', error);
        throw error; // Re-throw the error to be handled by the caller if needed
    }
}


// Hover TOOLTIP SHOW-----------------------
var myDivs = document.querySelectorAll('.cb-configurator__chocolate-selector__grid__item.in-stock');
myDivs.forEach(function(div) {
    div.addEventListener('mouseover', function() {
        var tooltip = div.querySelector('.cb-configurator__chocolate-selector__grid__item__tooltip');
      if(tooltip !=  "undefined" && tooltip !=null ){
        var mainContainer = document.querySelector(".tooptip_container")
        var rect = div.getBoundingClientRect();
        tooltip.classList.add("active_tooltip")
        mainContainer.style.position = 'absolute'; // Ensure the tooltip is positioned absolutely
        mainContainer.style.left = rect.left + 'px'; // Position the tooltip horizontally
        mainContainer.style.top = (rect.top + window.scrollY ) + 100 + 'px'; // Position the tooltip below the hovered element
        mainContainer.innerHTML = tooltip?.outerHTML || '';
      }
    });
    
    // Optionally, hide the tooltip when the mouse leaves the element
    div.addEventListener('mouseleave', function() {
        var mainContainer = document.querySelector(".tooptip_container")
       mainContainer.innerHTML = " "
    });
});


// DULICATE PRODUCT REMOVE CODE ===-----------------------
$(document).ready(function() {
    var seen = {};
    $('.cb-configurator__chocolate-selector__grid__item.in-stock').each(function() {
        var $this = $(this);
        var dataAttr = $this.find('.cb-configurator__chocolate-selector__grid__item__image').data('variant-id');

        if (seen[dataAttr]) {
            $this.remove(); // Remove duplicate
        } else {
            seen[dataAttr] = true; // Mark as seen
        }
    });
});


// MOUSE lEAVE FILTER HIDE CODE HERE---------------------------------[]
var filterDiv = document.querySelectorAll('.cb-configurator__filters__filter__dropdown');
   filterDiv.forEach(div => {
   div.addEventListener('mouseleave', function() {
      $(div).closest('.cb-configurator__filters__filter').removeClass("active");
    });
   });


$(document).on("click", '.close-button', function() {
  $('.modal').removeClass('show-modal');
})

var productTitle = $('.product__title h1').text();
if(productTitle == 'Create Your Own Gummy Mix'){
  $('.product-form__input .Ctm-variants-itg').prop("checked", false)
}


